<shared-draw-bar-menu [relativeTarget]="relativeTarget" [registryId]="'accountPages'" [pages]="pages$ | async"
    [activePageId]="activePageId$ | async" (onPageClick)="handlePageClick($event)">
</shared-draw-bar-menu>